import { render } from "./COIActionBarReorder.vue?vue&type=template&id=63fe50ff"
import script from "./COIActionBarReorder.vue?vue&type=script&lang=js"
export * from "./COIActionBarReorder.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__